import React from "react";
import { Box, Typography } from "@mui/material";
import { getStyles } from "./ChildrenWishes.styles";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const ChildrenWishes = () => {
  const styles = getStyles();

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
      partialVisibilityGutter: 40,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
      partialVisibilityGutter: 30,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      partialVisibilityGutter: 20,
    },
  };

  const CustomLeftArrow = ({ onClick }: any) => (
    <Box onClick={onClick} sx={styles.arrowPrevious}>
      <img src="/assets/images/toggle.svg" alt="Previous" />
    </Box>
  );

  const CustomRightArrow = ({ onClick }: any) => (
    <Box onClick={onClick} sx={styles.arrowNext}>
      <img src="/assets/images/toggle.svg" alt="Next" />
    </Box>
  );

  return (
    <Box sx={styles.childrenWishesContainer}>
      <Box sx={styles.childrenWishesSection}>
        <Typography variant="h2" component="h2" gutterBottom>
          Ce își doresc copiii din România
        </Typography>

        <Carousel
          centerMode
          infinite
          responsive={responsive}
          autoPlay
          autoPlaySpeed={3000}
          customLeftArrow={<CustomLeftArrow />}
          customRightArrow={<CustomRightArrow />}
          className="carousel"
        >
          <Box sx={styles.messageBox}>
            <img src="/assets/images/messages/msg1.svg" alt="message1" />
          </Box>
          <Box sx={styles.messageBox}>
            <img src="/assets/images/messages/msg2.svg" alt="message2" />
          </Box>
          <Box sx={styles.messageBox}>
            <img src="/assets/images/messages/msg3.svg" alt="message3" />
          </Box>
          <Box sx={styles.messageBox}>
            <img src="/assets/images/messages/msg4.svg" alt="message4" />
          </Box>
          <Box sx={styles.messageBox}>
            <img src="/assets/images/messages/msg5.svg" alt="message5" />
          </Box>
        </Carousel>
      </Box>
    </Box>
  );
};

export default ChildrenWishes;
